import { render, staticRenderFns } from "./BBCheckbox.vue?vue&type=template&id=0a460207"
import script from "./BBCheckbox.vue?vue&type=script&lang=js"
export * from "./BBCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a460207')) {
      api.createRecord('0a460207', component.options)
    } else {
      api.reload('0a460207', component.options)
    }
    module.hot.accept("./BBCheckbox.vue?vue&type=template&id=0a460207", function () {
      api.rerender('0a460207', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/content/BBForm/BBCheckbox.vue"
export default component.exports